import { render, staticRenderFns } from "./EWLimitConfigShow.vue?vue&type=template&id=7d4b159e&"
import script from "./EWLimitConfigShow.vue?vue&type=script&lang=js&"
export * from "./EWLimitConfigShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports